// EVENTOS
import Constants from "../../AAF/Ads/Constans";

export const EVENT_SIGN_UP = "sign_up";
export const EVENT_LOGIN = "login";
export const EVENT_ADD_PAYMENT = "add_payment";
export const EVENT_SELECT_CONTENT = "select_content";
export const EVENT_BEGIN_CHECKOUT = "begin_checkout";
export const EVENT_VIEW_ITEM = "view_item";
export const EVENT_INTERACTION_CONTENT = "interaction_content";
export const EVENT_SHARE = "share";
export const EVENT_ADD_PAYMENT_INFO = "add_payment_info";
export const EVENT_PURCHASE = "purchase";
export const EVENT_CONTENT_PLAY = "content_play";
export const EVENT_CONTENT_PAUSE = "content_pause";
export const EVENT_CONTENT_BACK = "content_back";
export const EVENT_CONTENT_ADVANCE = "content_advance";
export const EVENT_CONTENT_PLAYER = "content_player";
export const EVENT_CONTENT_PROGRESS = "content_progress";
export const EVENT_INTERACTION_PLAYER = "interaction_player";
export const EVENT_SEARCH = "search";
export const PLAN_SELECTOR = "plan_selector"
export const EVENT_STILL_WATCHING = "still_watching";
export const EVENT_PROGRAM_OPTIONS = "program_options";

// corresponde al método de registro escogido por el usuario
export const METHOD_EMAIL = "correo electronico";
export const METHOD_PROMOCODE = "codigo promocional";
export const METHOD_TELCEL_PREPAGO = "telcel prepago";
export const METHOD_TELCEL_POSTPAGO = "telcel postpago";
export const METHOD_IPTELMEX = "ip telmex";
export const METHOD_FACEBOOK = "telcel postpago";
export type RegisterMethodType = typeof METHOD_EMAIL | typeof METHOD_PROMOCODE;
// corresponde al método de pago seleccionado por el usuario
export const PAYMENT_METHOD_TELMEX = "numero telmex";
export const PAYMENT_METHOD_TELCEL = "numero telcel";
export const PAYMENT_METHOD_CREDIT_CARD = "tarjeta de credito";
export const PAYMENT_METHOD_PROMO_CODE = "codigo promocional";
export type PaymentMethodType = typeof PAYMENT_METHOD_TELCEL | typeof PAYMENT_METHOD_CREDIT_CARD | typeof PAYMENT_METHOD_PROMO_CODE;
// corresponde al tipo de contrato
export const CONTRACT_TYPE_BUSSINESS = "negocio";
export const CONTRACT_TYPE_HOME = "hogar";
export type ContractType = typeof CONTRACT_TYPE_BUSSINESS | typeof CONTRACT_TYPE_HOME;
// sección del contenido
export const CONTENT_SECTION_START = "home inicio";
export const CONTENT_SECTION_HOME_MOVIES = "home peliculas";
export const CONTENT_SECTION_HOME_SERIES = "home series";
export const CONTENT_SECTION_HOME_KIDS = "home kids";
export const CONTENT_SECTION_HOME_MY_CONTENTS = "home mis contenidos";
export const CONTENT_SECTION_SUBCATEGORY = "subcategorias";
export const CONTENT_SECTION_ADDON = "home addon";
export const CONTENT_SECTION_ADDON_SUBCATEGORY = "addon subcategorias";
export const CONTENT_SECTION_SUBCATEGORY_TALEN = "subcategorias por talento";
export const CONTENT_SECTION_SEARCH = "buscador";
export const CONTENT_SECTION_VCARD = "vcard";
export const CONTENT_SECTION_END_PLAYER = "fin player";
export const CONTENT_SECTION_PLAYER = "player";
export const CONTENT_SECTION_PLAYER_TV = "player tv";
//corresponde al nombre de la lista de carruseles disponibles
export const CONTENT_LIST_HIGHLIGTH = "super destacados";
export const CONTENT_LIST_CONTINUE_WATCHING = "segui viendo";
export const CONTENT_LIST_TV_CHANNELS = "canales de tv";
export const CONTENT_LIST_PREMIUM_CHANNELS = "canales premium";
export const CONTENT_LIST_PREMIUM_CHANNELS_THE_BEST = "lo mejor de los canales premium";
export const CONTENT_LIST_LOMASPOP = "lo mas popular";
export const CONTENT_LIST_TOP = "lo mas top";
//Corresponde al tipo de contenido
export const CONTENT_TYPE_MOVIE = 'pelicula';
export const CONTENT_TYPE_SERIE = 'serie';
export const CONTENT_TYPE_DOCUMENTARY = 'documental';
export const CONTENT_TYPE_TV = 'canal tv';
//Tipo de disponibilidad del contenido
export const CONTENT_AVAILABILITY_FREE = 'gratuito';
export const CONTENT_AVAILABILITY_SUBSCRIPTION = 'por suscripcion';
export const CONTENT_AVAILABILITY_RENT = 'alquiler';
export const CONTENT_AVAILABILITY_ADDON_SUBSCRIPTION = 'por suscripcion addon';
export const CONTENT_AVAILABILITY_BUY_EPISODE = 'compra episodio';
export const CONTENT_AVAILABILITY_BUY_SEASON = 'compra temporada completa';
export const CONTENT_AVAILABILITY_BUY = 'comprar pelicula';
//Nombre de la interacción
export const CONTENT_INTERACTION_PLAY = 'reproducir';
export const CONTENT_INTERACTION_TRAILER = 'ver trailer';
export const CONTENT_INTERACTION_ADD_FAVORITE = 'agregar a mi lista';
export const CONTENT_INTERACTION_DELETE_FAVORITE = 'quitar de mi lista';
export const CONTENT_INTERACTION_LANGUAGE = 'idioma';
export type InteractionType = typeof CONTENT_INTERACTION_PLAY | typeof CONTENT_INTERACTION_TRAILER| typeof CONTENT_INTERACTION_ADD_FAVORITE| typeof CONTENT_INTERACTION_DELETE_FAVORITE| typeof CONTENT_INTERACTION_LANGUAGE;
// Tipo de usuario en la App de Claro video [anonimo|registrado]
export const USER_TYPE_ANONIMO = 'anonimo';
export const USER_TYPE_REGISTRADO = 'registrado';
//Terminos y Condiciones
export const EVENT_PRIVACY_POLICES = 'privacy_policies'
export const PRIVACY_POLICES_TERMS = 'terminos'
export const PRIVACY_POLICES_POLICES = 'politicas'
export const PRIVACY_POLICES_CONTINUE = 'continuar'

//
export const DOES_NOT_APPLY = 'no aplica';
export const DEVICE = 'aaf';
export const HOME_USER = 'homeuser';
export const HOME_USER_LITE = Constants.HOMEUSER_LITE;
export const HOME_USER_SECTION_G4 = 'home inicio';
export const NODE_PREMIUM = 'premium';
export const NODE_PREMIUM_LITE = 'premium_lite';
export const NODE_PREMIUM_SECTION_G4 = 'premium';
export const SUPERDESTACADOS = 'superdestacados';
export const TYPE_RIBBON_SUPERDESTACADOS = 'highlight';
export const DOSFATELMEX = '2fa_telmex';
export const INICIASESION = 'inicia sesion'
export const INTERACTIONFORGOTTENPASSWORD = 'interaction_forgotten_password';
export const HOME = 'home';
export const INICIO = 'inicio';
export const ENTENDIDO = 'entendido';
export const REVISABANDEJA = 'revisa bandeja';
export const SERIAL = 'serial';
export const SELECT_CONTENT = 'select_content';
export const SCROLL_MUNDIAL = 'scroll';
export const SCROLL_DIRECTION = 'vertical';
export const SPORTS = 'deportes'
export const VIEW_ITEM = 'view_item'
export const MUNDIAL_SELECT_CONTENT = 'select_content';
export const CONTENT_PLAY = 'content_play';
export const EVENT_ERROR = 'event_error';
export const ACTIVAR_HBO = 'Activar hbo';



// WEBPACK FOOTER //
// ./src/utils/trackers/GA4Constants.ts